import Child from './Child';
import { WithdrawRequestProvider } from './context/FormProvider';
import { FiatWithdrawRequestProvider } from './forms/fiat/context/FormProvider';
import { UsdWithdrawRequestProvider } from './forms/usd/context/FormProvider';

const DialogWithdrawRequest = () => (
	<WithdrawRequestProvider>
		<FiatWithdrawRequestProvider>
			<UsdWithdrawRequestProvider>
				<Child />
			</UsdWithdrawRequestProvider>
		</FiatWithdrawRequestProvider>
	</WithdrawRequestProvider>
);

export default DialogWithdrawRequest;
